module.exports = __webpack_public_path__ + "static/img/qaudio-image-2.31e90fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/qaudio-image-2.png
// module id = 112
// module chunks = 0